import { CARD_GET_BASIC_DETAILS, CARD_HEAD_CHANGE_AVATAR } from '../actions/cardHeader';
import {
    SEARCHMOBLESHOW,
    ACTION_USERINFO,
    CHANGE_TOKEN_PHONE,
    ACTION_LAWYER_USERINFO,
    ACTION_AVATAR,
} from '../actions/home';
import { IM_USER_INFO } from '../actions/imAction';
import { reducer as IMReducer } from '../components/IMPlatform';
import IMRes from './im';

const initialState = {
    name: '',
    avatar: '',
    firmName: '',
    userId: '',
};

// 待办日程
const scheduleInitialState = {
    remind: null,
    case: null,
    movement: null,
    member: null,
    time: null,
    scheduleTitle: null,
    id: null,
    jurisdiction: true,
};

// 首页搜索弹框状态
const homeSearchStatus = {
    searchMobleShow: false,
};

// 用户信息身份和律师基本信息
const userInfoData = {};

// IM 用户基本信息
const im_initialState = {};

export default {
    getPhoneToken(
        state = {
            phone: null,
            token: null,
            appVersion: '9.5.0',
        },
        action
    ) {
        switch (action.type) {
            case CHANGE_TOKEN_PHONE:
                state.phone = action.phone;
                state.token = action.token;
                state.appVersion = action.appVersion;
                state.hanukkahUserId = action.hanukkahUserId;
                state.email = action.email;
                return state;
            default:
                return state;
        }
    },

    loginReducer(state = initialState, action) {
        switch (action.type) {
            case CARD_HEAD_CHANGE_AVATAR:
                state.avatar = action.avatar;
                return { ...state };
            case CARD_GET_BASIC_DETAILS:
                return { ...state, ...action.basicDetials };
            default:
                return state;
        }
    },

    scheduleReducer(state = scheduleInitialState, action) {
        switch (action.type) {
            case 'ACCOUNTYPE':
                state.accountType = action.item;
                return { ...state };
            case 'REMIND':
                state.remind = action.remind;
                return { ...state };
            case 'CASE':
                state.case = action.item;
                return { ...state };
            case 'MOVEMENT':
                state.movement = action.item;
                return { ...state };
            case 'MEMBER':
                state.member = action.item;
                return { ...state };
            case 'TIME':
                state.time = action.item;
                return { ...state };
            case 'SCHEDULE':
                state.scheduleTitle = action.item;
                return { ...state };
            case 'GETID':
                state.id = action.item;
                return { ...state };
            case 'LINK':
                state.jurisdiction = action.item;
                return { ...state };
            default:
                return state;
        }
    },

    userInfo(state = userInfoData, action) {
        switch (action.type) {
            case ACTION_USERINFO:
                return {
                    ...state,
                    ...action.userInfo,
                };
            case ACTION_LAWYER_USERINFO:
                return {
                    ...state,
                    ...action.lawyerInfo,
                };
            case ACTION_AVATAR:
                state.userPhotoUrl = action.avatar;
                return {
                    ...state,
                };
            default:
                return state;
        }
    },

    changeSearchStatus(state = homeSearchStatus, action) {
        switch (action.type) {
            case SEARCHMOBLESHOW:
                state.searchMobleShow = action.item;
                return { ...state };
            default:
                return state;
        }
    },

    ...IMReducer,

    IMRes,

    imReducer(state = im_initialState, action) {
        switch (action.type) {
            case IM_USER_INFO:
                return {
                    ...state,
                    ...action.imUserInfo,
                };
            default:
                return state;
        }
    },
};
